import DocxTemplate from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import JSZip from 'jszip';
// import toPdf from 'custom-soffice-to-pdf'
// import toPdf  from "office-to-pdf"
const FILE_NAME = `/${process.env.VUE_APP_APP_ID}`
var DocxMerger = require('docx-merger');
import flat from "flat";
import {saveAs} from "file-saver";
import {getGradeFullName, getPupilFullName} from "@/utils/parseObj";

const nullGetter = (part, scopeManager) => {
    return "";
}

const prepareObj = (object, userName, gradeId, dateHebrew, reportName, oldReportToPrint) => {
    console.log("object",object)
    if (object?.ratedScores){
        const ratedScores = Object?.keys(object?.ratedScores)
        ratedScores?.forEach(key => {
            const score = object.ratedScores[key]?.score
            object.ratedScores[key][`${score}`] = '✔️'
        })
    }

    object.old = oldReportToPrint
    if (object?.old?.ratedScores){
        const ratedScores = Object?.keys(object.old.ratedScores)
        ratedScores?.forEach(key => {
            const score = object.old.ratedScores[key]?.score
            object.old.ratedScores[key][`${score}`] = '✔️'
        })
    }

    object.p = object?.presenceScores
    object.b = object?.behaviorScores
    object.t = object?.topicScores
    object.r = object?.ratedScores

    const flatObj = flat(object)
    const gradeName = getGradeFullName(gradeId)
    flatObj.grade = gradeName.split(" ")[0]
    flatObj.nameReport = reportName
    flatObj.pupil = getPupilFullName(flatObj.pupil)
    flatObj.teacher = userName
    flatObj.date = dateHebrew
    console.log(flatObj)
    return flatObj;
}

export const printReports = (objects, userName, gradeId, dateHebrew, oneFile = false, reportName, reportStampName, oldReportToPrints, errorBlock) => {
    try {
        let fileName
        if (process.env.VUE_APP_APP_ID === "or-menachem-banott"){
             fileName = `${FILE_NAME}${reportStampName}.docx`
        } else {
             fileName = `https://docs.google.com/document/d/${reportStampName}/export?format=doc`
        }

    // const fileName = `https://docs.google.com/document/d/1j_MAzLEEyZgHBs16mF1RNhN73PEeQ-lc/edit?usp=sharing&ouid=106592907302576780100&rtpof=true&sd=true`

    PizZipUtils.getBinaryContent(fileName, (error, content) => {
        let isError = false

        if (error) {
            throw 'error'
        }
        const zip2 = new JSZip();
        const finalDocxs = []
        objects.forEach(async object => {
            const oldReportToPrint = oldReportToPrints?.find(r => r.pupil === object.pupil)
            const Obj = prepareObj(object, userName, gradeId, dateHebrew, reportName, oldReportToPrint)
            try {
                const zip = new PizZip(content);

                const doc = new DocxTemplate(zip, {paragraphLoop: true, linebreaks: true, nullGetter});
                doc.setData(Obj);
                try {
                    doc.render();
                } catch (error) {
                    function replaceErrors(key, value) {
                        if (value instanceof Error) {
                            return Object.getOwnPropertyNames(value).reduce(function (
                                error,
                                key
                                ) {
                                    error[key] = value[key];
                                    return error;
                                },
                                {});
                        }
                        return value;
                    }

                    if (error.properties && error.properties.errors instanceof Array) {
                        const errorMessages = error.properties.errors
                            .map(function (error) {
                                return error.properties.explanation;
                            })
                            .join("\n");
                        // errorMessages is a humanly readable message looking like this :
                        // 'The tag beginning with "foobar" is unopened'
                    }
                    throw error;
                }
                const out = doc.getZip().generate({
                    type: "nodebuffer",
                    mimeType:
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                });
                finalDocxs.push(out)
                zip2.file(`${Obj.pupil}.docx`, out);
            } catch (e) {
                console.log( e)
                isError = true
                throw e
            }


        });
        if (isError === true){
            console.log("RUN ERROR")
            errorBlock()

            throw "error in for each"
        }
        if (oneFile) {
            var docx = new DocxMerger({}, finalDocxs);
            docx.save('blob', function (data) {
                saveAs(data, "output.docx");
            });
        } else {
            zip2.generateAsync({type: 'blob'}).then((content) => {
                saveAs(content, `${getGradeFullName(gradeId)}.zip`);
            });
        }

        // zip2.file(`13123`, docx);


    })
    } catch (e) {
        console.log("7777",e)
        throw e
    }
    if (isError){
        throw "error in for each"
    }
}
